/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Corrective_ExerciseInputs */

const en_service_type_corrective_exercise = /** @type {(inputs: Service_Type_Corrective_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrective exercise`)
};

const pl_service_type_corrective_exercise = /** @type {(inputs: Service_Type_Corrective_ExerciseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ćwiczenia korekcyjne`)
};

/**
* | output |
* | --- |
* | "Corrective exercise" |
*
* @param {Service_Type_Corrective_ExerciseInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_corrective_exercise = /** @type {((inputs?: Service_Type_Corrective_ExerciseInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Corrective_ExerciseInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_corrective_exercise(inputs)
	return en_service_type_corrective_exercise(inputs)
});